import {
  Odometer,
  UserFilled,
  Avatar,
  List,
  Coin,
  Setting,
  Grid,
  Warning,
  Document,
  PhoneFilled,
  ChatDotRound,
  DocumentChecked,
  Ticket,
  OfficeBuilding,
  Headset,
  Message,
  Timer,
  Tools,
} from '@element-plus/icons-vue'

export const adminNavItems = [
  { id: 'dashboard', path: '/dashboard', label: 'Tableau de bord', icon: Odometer, permissions: ['dashboard.read'], group: 'Opérations' },
  { id: 'dispatch', path: '/dispatch', label: 'Dispatch Support', icon: Headset, permissions: ['dispatch.create'], group: 'Opérations' },
  { id: 'waitlist', path: '/waitlist', label: 'Waitlist', icon: Timer, permissions: ['missions.read.any'], group: 'Opérations' },
  { id: 'missions', path: '/missions', label: 'Missions', icon: List, permissions: ['missions.read.any'], group: 'Opérations' },
  { id: 'chat', path: '/chat', label: 'Conversations', icon: ChatDotRound, permissions: ['chat.read.any'], group: 'Opérations' },

  { id: 'artisans', path: '/artisans', label: 'Artisans', icon: UserFilled, permissions: ['artisans.read.any'], group: 'Utilisateurs' },
  { id: 'clients', path: '/clients', label: 'Clients', icon: Avatar, permissions: ['clients.read.any'], group: 'Utilisateurs' },
  { id: 'orgs', path: '/orgs', label: 'Comptes Pro (B2B)', icon: OfficeBuilding, permissions: ['orgs.read.any'], group: 'Utilisateurs' },
  { id: 'users', path: '/users', label: 'Comptes Admin', icon: Setting, permissions: ['users.read.any'], group: 'Utilisateurs' },

  { id: 'finance', path: '/finance', label: 'Finance', icon: Coin, permissions: ['finance.read.any'], group: 'Administration' },
  { id: 'categories', path: '/categories', label: 'Categories', icon: Grid, permissions: ['categories.manage'], group: 'Administration' },
  { id: 'promos', path: '/promos', label: 'Codes Promo', icon: Ticket, permissions: ['promos.manage'], group: 'Administration' },

  { id: 'sav', path: '/sav', label: 'Service Apres Vente', icon: PhoneFilled, permissions: ['sav.read.any'], group: 'Support & Séc.' },
  { id: 'fraud', path: '/fraud', label: 'Antifraude', icon: Warning, permissions: ['fraud.read.any'], group: 'Support & Séc.' },
  { id: 'disputes', path: '/disputes', label: 'Litiges', icon: Document, permissions: ['disputes.read.any'], group: 'Support & Séc.' },
  { id: 'reports', path: '/reports', label: 'Signalements', icon: Warning, permissions: ['reports.read.any'], group: 'Support & Séc.' },

  { id: 'settings', path: '/settings', label: 'Paramètres', icon: Tools, permissions: ['settings.read', 'settings.manage'], group: 'Système' },
  { id: 'sms', path: '/sms', label: 'SMS Center', icon: Message, permissions: ['sms.logs.read', 'sms.policy.manage', 'sms.broadcast.send'], group: 'Système' },
  { id: 'push', path: '/push', label: 'Push Center', icon: Message, permissions: ['sms.logs.read', 'sms.broadcast.send'], group: 'Système' },
  { id: 'audit', path: '/audit', label: "Journal d'audit", icon: DocumentChecked, permissions: ['audit.read.any'], group: 'Système' },
]

const hasAnyPermission = (userPermissions = [], requiredPermissions = []) =>
  requiredPermissions.some((code) => userPermissions.includes(code))

export const navItemsForUser = (user) => {
  const permissions = Array.isArray(user?.permissions) ? user.permissions : []
  return adminNavItems.filter((item) => hasAnyPermission(permissions, item.permissions || []))
}

export const defaultPathForUser = (user) => {
  const firstItem = navItemsForUser(user)[0]
  return firstItem?.path || '/login'
}

export const navItemById = (id) => adminNavItems.find((item) => item.id === id) || null
export const userHasAnyPermission = hasAnyPermission
